import React, { useEffect, useState, useRef } from "react";
import APIUrls from "../../services/APIUrls";
import {
  getAxiosResponse,
  getAxiosResponseAndSetStateForArrayProjectFilters,
} from "../../services/authApiRoutes/APImethods";
import { useSelector, useDispatch } from "react-redux";
import { updateSelectedFilters } from "../../redux/reducers/ProjectFilterSlice";
import Constants from "../../Constants";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { aaaChecked } from "../../redux/reducers/ContrastSlice";
import $ from "jquery";
import { useSearchParams} from "react-router-dom";
import { handleError } from "../../services/authApiRoutes/APImethods";

export default function RightModal(prop) {
  const { t } = useTranslation();
  const filterRef = useRef(null);
  const inputref = useRef(null);
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [params ,setParams] =useSearchParams();
  const id = params.get('id'); 
  const tag = params.get('tag');
  const dispatch = useDispatch();

  function hideRightModel() {
       $('#advance-activeId').trigger('focus');
	     prop.funct(false)
      document.body.classList.remove("modal-open");
  }
  $("#close-right-popup").on("keydown", function (e) {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === true) {
        e.preventDefault();
        $("#apply-id").trigger("focus");
      }
    }
  })
  const handleModalFocus = (event) => {
    if (document.activeElement.id === "apply-id" &&
    event.key === Constants.TAB &&
    event.shiftKey === false) {
    event.preventDefault();
    $("#close-right-popup").trigger("focus");
    }
  }

  const [intendedUses, updateIntendedUses] = useState([]);
  const [campaigns, updateCampaigns] = useState([]);
  const [contentSources, updateContentSources] = useState([]);
  const [vendors, updateVendors] = useState([]);
  const [projectOwners, updateProjectOwners] = useState([]);
  const [purchaseOrders, updatePurchaseOrders] = useState([]);
  const [sourcelanguages, updateSourceLanguages] = useState([]);
  const [tags, updateTags] = useState([]);
  const [targetLanguages, updateTargetLanguages] = useState([]);
  const translate = t;

  const [selectedCampaign, updateSelectedCampaign] = useState({
    label: "",
    value: "",
  });
  const [selectedDeliveryStatus, updateSelectedDeliveryStatus] = useState({
    label: "",
    value: "",
  });
  const [selectedIntendedUse, updateSelectedIntendedUse] = useState({
    label: "",
    value: "",
  });
  const [selectedProjectId, updateSelectedProjectId] = useState({ label: "" });
  const [selectedContentSource, updateSelectedContentSource] = useState({
    label: "",
    value: "",
  });
  const [selectedVendor, updateSelectedVendor] = useState({
    label: "",
    value: "",
  });
  const [selectedProjectOwner, updateSelectedProjectOwner] = useState({
    label: "",
    value: "",
  });
  const [selectedPurchaseOrder, updateSelectedPurchaseOrder] = useState({
    label: "",
    value: "",
  });
  const [selectedSourceLanguage, updateSelectedSourceLanguage] = useState({
    label: "",
    value: "",
  });
  const [selectedTag, updateSelectedTag] = useState({ label: "", value: "" });
  const [selectedTargetLanguage, updateSelectedTargetLanguage] = useState({
    label: "",
    value: "",
  });

  const selectedProjectFilters = useSelector(
    (updateSelectedFilters) => updateSelectedFilters.project_filters
  );

  useEffect(() => {
    setFilters();
    getAxiosResponseAndSetStateForArrayProjectFilters(
      APIUrls.PROJECT_LISTING_INTENDED_USES,
      updateIntendedUses
    );

    getAxiosResponseAndSetStateForArrayProjectFilters(
      APIUrls.PROJECT_LISTING_WORKSPACES,
      updateCampaigns
    );

    getAxiosResponse(APIUrls.PROJECT_LISTING_CONTENT_SOURCES)
      .then((res) => {
        if (res.data.code === 200) {
          const options = [{ label: Constants.SELECT, value: Constants.SINGLE_WHITESPACE}];
          res.data.data.map(({ display, code }) =>{
            if(display !== "" && code !==""){
            options.push({
              label: display,
              value: code,
            })
          }}
          );
          updateContentSources(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponseAndSetStateForArrayProjectFilters(
      APIUrls.PROJECT_LISTING_VENDORS,
      updateVendors
    );

    getAxiosResponse(APIUrls.PROJECT_LISTING_PROJECT_OWNERS)
      .then((res) => {
        if (res.data.code === 200) {
          const options = [{ label: Constants.SELECT, value: Constants.SINGLE_WHITESPACE}];
          res.data.data.map(({ userId, firstName, lastName }) =>
            options.push({
              label: firstName + " " + lastName,
              value: userId,
            })
          );
          updateProjectOwners(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.PROJECT_LISTING_PURCHASE_ORDERS)
      .then((res) => {
        if (res.data.code === 200) {
          const options = [{ label: Constants.SELECT, value: Constants.SINGLE_WHITESPACE }];
          res.data.data.map(({ poNumber, poName }) =>
            options.push({
              label: poName,
              value: poNumber,
            })
          );
          updatePurchaseOrders(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.PROJECT_LISTING_SOURCE_LANGUAGES)
      .then((res) => {
        if (res.data.code === 200) {
          const options = [{ label: Constants.SELECT, value: Constants.SINGLE_WHITESPACE}];
          res.data.data.map(({ code, display }) =>
            options.push({
              label: display,
              value: code,
            })
          );
          updateSourceLanguages(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.PROJECT_LISTING_TAGS)
      .then((res) => {
        if (res.data.code === 200) {
          const options = [{ label: Constants.SELECT, value: Constants.SINGLE_WHITESPACE}];
          res.data.data.result.map(({ id, display }) =>
            options.push({
              label: display,
              value: id,
            })
          );
          updateTags(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.PROJECT_LISTING_TARGET_LANGUAGES)
      .then((res) => {
        if (res.data.code === 200) {
          const options = [{ label: Constants.SELECT, value: Constants.SINGLE_WHITESPACE}];
          res.data.data.map(({ code, display }) =>
            options.push({
              label: display,
              value: code,
            })
          );
          updateTargetLanguages(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });
   $(".project-filters-modal").on("keydown", function (e) {
      let allAreFalse = true;
      $('.cw__control').each(function() {
        if ($(this).find('input').attr('aria-expanded') !== 'false') {
          allAreFalse = false;
          return false;
        }
      });
      if (e.key === Constants.ESCAPE && allAreFalse) {
         hideRightModel();
      }
    });
  }, []);

  const setFilters = () => {
    if(selectedProjectFilters?.Campaign?.label && selectedProjectFilters?.Campaign?.label !== Constants.SELECT) {
      updateSelectedCampaign(selectedProjectFilters.Campaign);
    }
    if(selectedProjectFilters?.Delivery_Status?.label && selectedProjectFilters?.Delivery_Status?.label !== Constants.SELECT) {
      updateSelectedDeliveryStatus(selectedProjectFilters.Delivery_Status);
    }
    if(selectedProjectFilters?.Content_Source?.label && selectedProjectFilters?.Content_Source?.label !== Constants.SELECT) {
      updateSelectedContentSource(selectedProjectFilters.Content_Source);
    }
    if(selectedProjectFilters?.Intended_Use?.label && selectedProjectFilters?.Intended_Use?.label !== Constants.SELECT) {
      updateSelectedIntendedUse(selectedProjectFilters.Intended_Use);
    }
    if(selectedProjectFilters?.Project_Id?.label && selectedProjectFilters?.Project_Id?.label !== Constants.SELECT) {
      updateSelectedProjectId(selectedProjectFilters.Project_Id);
    }
    if(selectedProjectFilters?.Translations_By?.label && selectedProjectFilters?.Translations_By?.label !== Constants.SELECT) {
      updateSelectedVendor(selectedProjectFilters.Translations_By);
    }
    if(selectedProjectFilters?.Project_Owner?.label && selectedProjectFilters?.Project_Owner?.label !== Constants.SELECT) {
      updateSelectedProjectOwner(selectedProjectFilters.Project_Owner);
    }
    if(selectedProjectFilters?.Purchase_Order?.label && selectedProjectFilters?.Purchase_Order?.label !== Constants.SELECT) {
      updateSelectedPurchaseOrder(selectedProjectFilters.Purchase_Order);
    }
    if(selectedProjectFilters.Source_Language?.label && selectedProjectFilters?.Source_Language?.label !== Constants.SELECT) {
      updateSelectedSourceLanguage(selectedProjectFilters.Source_Language);
    }
    if(selectedProjectFilters?.Tags?.label && selectedProjectFilters?.Tags?.label !== Constants?.SELECT) {
      updateSelectedTag(selectedProjectFilters.Tags);
    }
    if(selectedProjectFilters?.Target_Language?.label && selectedProjectFilters?.Target_Language?.label !== Constants.SELECT) {
      updateSelectedTargetLanguage(selectedProjectFilters.Target_Language);
    }
  }

  const handleOnApply = () => {
    const selectedFilters = {
      Campaign: selectedCampaign.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedCampaign,
      Delivery_Status: selectedDeliveryStatus.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedDeliveryStatus,
      Content_Source: selectedContentSource.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedContentSource,
      Intended_Use: selectedIntendedUse.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedIntendedUse,
      Project_Id: selectedProjectId,
      Translations_By: selectedVendor.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedVendor,
      Project_Owner: selectedProjectOwner.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedProjectOwner,
      Purchase_Order: selectedPurchaseOrder.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedPurchaseOrder,
      Source_Language: selectedSourceLanguage.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedSourceLanguage,
      Tags: selectedTag.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedTag,
      Target_Language: selectedTargetLanguage.value === Constants.SINGLE_WHITESPACE ? {label: '', value: ''} : selectedTargetLanguage,
    };
    dispatch(updateSelectedFilters(selectedFilters));
    hideRightModel();
  };

  const deliveryStatus = [
    {
      label: Constants.SELECT,
      value: Constants.SINGLE_WHITESPACE
    },
    {
      label: `${t("delivery_status.on_track")}`,
      value: Constants.DELIVERY_STATUS_ON_TRACK,
    },
    {
      label: `${t("delivery_status.at_risk")}`,
      value: Constants.DELIVERY_STATUS_AT_RISK,
    },
    {
      label: `${t("delivery_status.late")}`,
      value: Constants.DELIVERY_STATUS_LATE,
    },
    {
      label: `${t("delivery_status.unknown")}`,
      value: Constants.DELIVERY_STATUS_UNKNOWN,
    },
  ];

  return (
    <div className="right-modal campaign-right-modal project-filters-modal" role="dialog" aria-labelledby="advanced-filters" aria-modal="true">
      <div className="modal-header flex">
        <div className="left flex-center" tabIndex={0}  >
          <strong id='advanced-filters'>{translate("project_listing.advanced_filters")}</strong>
        </div>
        <button
          className="close flex-center"
          aria-label="Close"
          onClick={hideRightModel}
          id='close-right-popup'
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
          >
            <path
              d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
              fill="white"
            />
            <path
              d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
      <div className="modal-content project-filter-content">
        <h4 aria-level={1}>{translate("project_listing.filter_by_column")}</h4>
        <div className="filter-selector">
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Campaign"
              aria-label="Campaign"
              placeholder={translate("project_listing.campaigns")}
              options={campaigns}
              defaultValue={1}
              isLoading={campaigns.length === 0}
              onChange={(value) => updateSelectedCampaign(value)}
              value={campaigns.filter(function (option) {
                return option.value === selectedCampaign.value;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Delivery Status"
              aria-label="Delivery Status"
              placeholder={translate("project_listing.delivery_status")}
              options={deliveryStatus}
              defaultValue={1}
              onChange={(value) => updateSelectedDeliveryStatus(value)}
              value={deliveryStatus.filter(function (option) {
                return option.value === selectedDeliveryStatus.value;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Content Source"
              aria-label="Content Source"
              placeholder= {translate("project_listing.content_sources")}
              options={contentSources}
              onChange={(value) => updateSelectedContentSource(value)}
              value={contentSources.filter(function (option) {
                return option.value === selectedContentSource.value;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Intended Use"
              aria-label="Intended Use"
              placeholder={translate("project_listing.intended_use")}
              options={intendedUses}
              defaultValue={1}
              onChange={(value) => updateSelectedIntendedUse(value)}
              value={intendedUses.filter(function (option) {
                return option.value === selectedIntendedUse.value;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <input
              placeholder={translate("project_listing.project_id")}
              onChange={(e) => {
                updateSelectedProjectId({ label: e.target.value });
              }}
			  ref={inputref}
              className="form-control-sm"
              value={selectedProjectId.label}
              type="number"
            ></input>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Translations by"
              aria-label="Translations by"
              placeholder={translate("project_listing.translation_by")}
              options={vendors}
              onChange={(value) => updateSelectedVendor(value)}
              value={vendors.filter(function (option) {
                return option.value === selectedVendor.value;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Project Owner"
              aria-label="Project Owner"
              placeholder={translate("project_listing.project_owner")}
              options={projectOwners}
              onChange={(value) => updateSelectedProjectOwner(value)}
              value={projectOwners.filter(function (option) {
                return option.value === selectedProjectOwner.value;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Purchase Order"
              aria-label="Purchase Order"
              placeholder={translate("project_listing.purchase_order")}
              options={purchaseOrders}
              onChange={(value) => updateSelectedPurchaseOrder(value)}
              value={purchaseOrders.filter(function (option) {
                return option.value === selectedPurchaseOrder.value;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Source Language"
              aria-label="Source Language"
              placeholder={translate("project_listing.sources_language")}
              options={sourcelanguages}
              onChange={(value) => updateSelectedSourceLanguage(value)}
              value={sourcelanguages.filter(function (option) {
                return option.value === selectedSourceLanguage.value;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Tag"
              aria-label="Tag"
              placeholder={translate("project_listing.tag")}
              options={tags}
              onChange={(value) => updateSelectedTag(value)}
              value={tags.filter(function (option) {
                return option.label === selectedTag.label;
              })}
            ></Select>
          </div>
          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "black" : "#1C233C",
                }),
              }}
              name="Target Language"
              aria-label="Target Language"
              placeholder={translate("project_listing.target_language")}
              options={targetLanguages}
              onChange={(value) => updateSelectedTargetLanguage(value)}
              value={targetLanguages.filter(function (option) {
                return option.value === selectedTargetLanguage.value;
              })}
            ></Select>
          </div>
          <div className="button-group flex">
            <button className="btn default-btn first-focus" onClick={hideRightModel}>
              {translate("project_listing.cancel")}
            </button>
            <button className="btn" id='apply-id' onClick={handleOnApply} onKeyDown={(e) => handleModalFocus(e)}>
            {translate("project_listing.apply")}

            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
